import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-187" data-mp="hvgl64lgx6wp">
      <div className="mx-auto max-w-6xl" data-id="element-188" data-mp="3zv20e1x1hc7">
        <SectionHeading id="volumes-heading" title={<>
              One Complete System. <Accent data-id="element-190" data-mp="vpzi40in7i7m">Six Essential Volumes.</Accent>
            </>} data-id="element-189" data-mp="7yu47qw9izzy" />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-191" data-mp="10oapm4lgtgmo">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col overflow-hidden rounded-[22px] bg-white shadow-[0_24px_50px_-36px_rgba(24,45,42,0.45)] ring-1 ring-brand-gold/25" data-id="element-192" data-mp="mvuwbvid8wyy">
              <div className="relative flex min-h-[170px] flex-col px-6 pb-6 pt-5" style={{
            backgroundColor: volume.accent
          }} data-id="element-193" data-mp="1elpkhouhmgm1">
                <span aria-hidden="true" className="pointer-events-none absolute right-5 top-2 font-script text-[3.5rem] leading-none text-white/80" data-id="element-194" data-mp="ckzxypa4mldm">
                  {volume.number}
                </span>
                <span className="relative self-start rounded-full bg-white/80 px-3 py-1 font-body text-[10px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/80" data-id="element-195" data-mp="mcds0hjb6szd">
                  Volume {volume.number}
                </span>
                <h3 className="relative mt-auto pt-5 font-display text-[1.4rem] font-bold leading-[1.12] text-brand-charcoal" data-id="element-196" data-mp="ra5rpxq73je4">
                  {volume.title}
                </h3>
              </div>
              <div className="flex flex-1 flex-col px-6 py-5" data-id="element-197" data-mp="10au6wvrbrpsl">
                <span aria-hidden="true" className="block h-px w-10 bg-brand-gold/60" data-id="element-198" data-mp="10bn69bnyfd0p" />
                <p className="mt-3 text-[14px] leading-relaxed text-brand-charcoal/70" data-id="element-199" data-mp="371tp1u94fdxg">{volume.description}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-200" data-mp="15zu86ttjgauc">
          Digital PDF resources. Assessment and completion materials are for classroom organization only — they do
          not grant professional licenses, certification authority, or permission to perform PMU procedures.
        </p>
      </div>
    </section>;
}